<template>
  <v-content>
    <v-container>
      <v-layout align-center justify-center my-12>
        <v-card width="650" class="pb-3">
          <v-card-title primary-title>
            {{ $t("general.legal.legalDocuments") }}
          </v-card-title>
          <v-card-text class="mt-2">
            <a :href="getLinks.privacyPolicy" target="_blank">
              <p class="mb-1">{{ $t("general.legal.privacyPolicy") }}</p>
            </a>
          </v-card-text>
          <v-card-text>
            <a :href="getLinks.termsOfUse" target="_blank">
              <p class="mb-1">{{ $t("general.legal.termsOfUse") }}</p>
            </a>
          </v-card-text>
          <v-card-text v-if="getLinks.legalNotice">
            <a :href="getLinks.legalNotice" target="_blank">
              <p class="mb-1">{{ $t("general.legal.legalNotice") }}</p></a
            >
          </v-card-text>
          <v-card-text v-if="getLinks.termsAndConditions">
            <a
              :href="getLinks.legalNotice"
              @click="handleLearnMore('tac')"
              target="_blank"
              ><p class="mb-1">
                {{ $t("users.dealersAddEdit.termsAndConditions") }}
              </p></a
            >
            <information-dialog
              v-if="learnMoreDialog.active"
              :dialog="learnMoreDialog"
              @agree="handleLearnMoreDialog"
            ></information-dialog>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/utils/api.js";
import InformationDialog from "@/components/dialogs/InformationDialog.vue";
export default {
  components: { InformationDialog },
  computed: {
    ...mapGetters(["getMe", "getLinks", "getTheme"]),
  },
  data: () => ({
    learnMoreDialog: { active: false },
  }),
  methods: {
    handleLearnMore(event) {
      this.learnMoreDialog = {
        active: false,
        text: "",
        title: "",
        options: {},
      };

      if (event == "tac") {
        api.getPartnerTac().then((resp) => {
          this.learnMoreDialog = {
            active: true,
            text: resp.data,
            title: this.$t("users.dealersAddEdit.termsAndConditions"),
            options: {
              persistent: false,
              width: 600,
              noTitle: true,
              html: true,
              disableReject: true,
              confirmText: this.$t("users.dealersAddEdit.close"),
              scrollable: true,
            },
          };
        });
      }
    },

    handleLearnMoreDialog() {
      this.learnMoreDialog = {
        active: false,
        text: "",
        title: "",
        options: {},
      };
    },
  },
};
</script>
